import green from '@material-ui/core/colors/green';

const styles = theme => ({
    root: {
        maxWidth: '100%'
    },
    success: {
        background: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        background: theme.palette.primary.dark
    },
    warning: {
        background: theme.palette.warning.main,
        color: theme.palette.warning.contrastText
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1)
    },
    message: {
        display: 'flex',
        alignItems: 'center'
    }
});

export default styles;